export default function TrainingAdminMediaListDirective() {
  return {
    template: require('./media-list.directive.html'),
    controller: 'TrainingAdminMediaListDirectiveController',
    controllerAs: 'trainingAdminMediaListVM',
    bindToController: true,
    scope: {
      topics: '=',
    },
    replace: true,
  };
}
